export const determineArrows = (dashboardPos, arrMargin, offset) => {
  if (dashboardPos <= arrMargin) {
    return { leftArrow: true, rightArrow: false };
  } else if (dashboardPos < offset) {
    return { leftArrow: false, rightArrow: false };
  } else if (dashboardPos >= offset) {
    return { leftArrow: false, rightArrow: true };
  }
};
